import { ContentType } from 'proto/generated/tintin_content_policy';
import { CONTENT_TYPE } from 'containers/ContentReporting/ContentLegalReporting/utils/types';

// @ts-ignore
export const CONTENT_TYPE_MAPPER: Record<ContentType, CONTENT_TYPE> = {
  [ContentType.CONTENT_TYPE_ARTIST_BANNER_IMAGE]: CONTENT_TYPE.ARTIST_BANNER_IMAGE,
  [ContentType.CONTENT_TYPE_ARTIST_GALLERY_IMAGE]: CONTENT_TYPE.ARTIST_GALLERY_IMAGE,
  [ContentType.CONTENT_TYPE_ARTIST_PROFILE_IMAGE]: CONTENT_TYPE.ARTIST_PROFILE_IMAGE,
  [ContentType.CONTENT_TYPE_ARTWORK]: CONTENT_TYPE.ARTWORK,
};
